import { FC } from "react";
import { Typography, Switch, Stack, Tooltip } from "@mui/material";
import { useVirtualBatteries } from "./hooks/useVirtualBatteries";
import useAuth from "@/components/Authentication/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { IBateriaVirtual } from "./types/virtualBattery";


export interface IVirtualBatteryDiscountToggleProps {
  bateriaVirtual: IBateriaVirtual;
}

const VirtualBatteryDiscountToggle: FC<IVirtualBatteryDiscountToggleProps> = ({
  bateriaVirtual
}) => {

  const { t } = useTranslation();
  const { tokenVals } = useAuth();

  const { 
    virtualBatteryTypes,
    handleBatteryTypeChange
  } = useVirtualBatteries();
  
  return (
    <Tooltip
      title={tokenVals?.readonly &&
        t("common:text.token_readonly_tooltip")
      }
      placement="right"
      arrow
      disableFocusListener={!tokenVals?.readonly}
      disableHoverListener={!tokenVals?.readonly}
      disableTouchListener={!tokenVals?.readonly}
      slotProps={{
        popper: {
          modifiers: [{
            name: 'offset',
            options: {offset: [0, -5]}
          }]
        }
      }}
    >
      <Stack direction="row" width={"fit-content"}>
      
        <Typography
          variant="body1"
          style={{
            color: bateriaVirtual.gestio_descomptes === "aplicar" ? "gray" : "black",
            marginTop: '6px'
          }}
        >
          {t("common:text.generic_no")}
        </Typography>

        <Switch
          disabled={!!tokenVals?.readonly}
          checked={bateriaVirtual.gestio_descomptes === "aplicar"}
          onChange={(e) =>
            handleBatteryTypeChange(
              e.target.checked
                ? virtualBatteryTypes[1].name //"aplicar"
                : virtualBatteryTypes[0].name, //"no_aplicar"
                bateriaVirtual.id
            )
          }
        />

        <Typography
          variant="body1"
          style={{
            color: bateriaVirtual.gestio_descomptes === "aplicar" ? "black" : "gray",
            marginTop: '6px'
          }}
        >
          {t("common:text.generic_yes")}
        </Typography>
      </Stack>
    </Tooltip>
  );
};

export default VirtualBatteryDiscountToggle;
